import React, { useState } from "react";
import { HiMenu, HiMenuAlt4, HiX } from "react-icons/hi";
import { motion, useAnimationControls } from "framer-motion";

import { images, sections } from "./../../constants";
// Style
import "./Navbar.scss";

const Navbar = () => {
  const [toggle, setToggle] = useState(false);
  const controls = useAnimationControls();
  const openMenu = () => {
    setToggle(true);
    controls.start({ x: [300, 0] });
  };

  const closeMenu = () => {
    setToggle(false);
    // controls.start({ x: [0, 300], duration: 0.25 });
  };

  return (
    <nav className="app__navbar">
      {!toggle && (
        <HiMenuAlt4 className="icon-menu open-menu" onClick={openMenu} />
      )}
      <div className="app__navbar-logo">
        <img src={images.Ai_brand3} alt="me portfolio" />
      </div>
      {/* Logo */}
      <motion.div
        className={`app__navbar-links ${toggle && "active"}`}
        animate={controls}
        transition={{ duration: 0.85, ease: "easeInOut" }}
      >
        <div className="icon-menu close-icon">
          <HiX onClick={closeMenu} />
        </div>
        {/* Close Logo */}

        <ul>
          {sections.map((link) => (
            <li key={`link-${link}`}>
              <a href={`#${link}`} className="bold-text">
                {link}
              </a>
            </li>
          ))}
        </ul>
        {/* List of items */}
      </motion.div>
    </nav>
  );
};

export default Navbar;
